import { FC } from "react"
import { Link, LinkProps, useSearchParams } from "react-router-dom"

type Props = LinkProps

export const CustomLink: FC<Props> = ({ to, children, ...props }) => {
  const [searchParams] = useSearchParams()
  const currentParams = searchParams.toString()

  const getTargetLocation = () => {
    if (to === "#" || !currentParams) return to

    const pathString = typeof to === "string" ? to : `${to.pathname || ""}${to.search || ""}`

    const separator = pathString.includes("?") ? "&" : "?"

    return `${pathString}${separator}${currentParams}`
  }

  return (
    <Link to={getTargetLocation()} {...props}>
      {children}
    </Link>
  )
}
